module.exports = __webpack_public_path__ + "static/media/CartEmpty.fd1aff08.svg";